.designContentContainer {
  height: calc(var(--container-width) * var(--aspect-ratio));
  width: var(--container-width);
}
